import { BriefcaseBusiness, Users } from 'lucide-react'
import { useContext } from 'react'

import SensitiveFieldRow from 'components/brokers/SensitiveFieldRow'
import EmployerContext from 'components/context/EmployerContext'
import { Badge } from 'slab'
import { getBusinessTypeDisplayText } from 'utils/employer_utils'

import { CollapsibleDataContainer } from '../reusable/CollapsibleDataContainer'
import { CopyFieldRow } from '../reusable/CopyFieldRow'
import TableSkeleton from '../reusable/table/Skeleton'

export default function EmployerCorporateStructure () {
  const { profile } = useContext(EmployerContext)

  const heading = (
    <div className='flex items-center space-x-2'>
      <span className='heading-md'>Corporate structure</span>

      {/* Business Type Badge */}
      {profile?.business_type && (<Badge type='info' leftIcon={BriefcaseBusiness}>{getBusinessTypeDisplayText(profile?.business_type)}</Badge>)}

      {/* Number of Employees Badge */}
      {profile?.number_of_employees && (<Badge type='info' leftIcon={Users}>{`${profile?.number_of_employees} employees`}</Badge>)}
    </div>
  )

  const successContent = (
    <dl className='divide-y divide-gray-100 p-4'>
      <CopyFieldRow label='Business Type' value={getBusinessTypeDisplayText(profile?.business_type)} />
      <CopyFieldRow label='Number of Employees' value={profile?.number_of_employees?.toString()} />
      <SensitiveFieldRow
        enableCopyButton
        isHidden
        label='EIN'
        value={profile?.ein}
      />
    </dl>
  )

  return (
    <CollapsibleDataContainer
      heading={heading}
      isLoading={!profile}
      error={!profile}
      localStorageKey='employerInformationOpenByDefault'
      loadingContent={<TableSkeleton rowCount={3} columnCount={3} />}
      errorContent={
        <div className='p-4 text-center text-red-500'>
          Error loading employer information
        </div>
      }
      successContent={successContent}
    />
  )
}
